import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

import RemoveDocButton from "./RemoveDocButton";
const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: "1ps xolid gray",
  position: "relative",
}));

interface IDoc {
  title: string;
  filePath: string;
}

interface Props {
  docs: IDoc[];
  handleDeleteFile: (index: number) => void;
}

export default function PreviewBox(props: Props) {
  const { docs, handleDeleteFile } = props;
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "16px",
        border: "1px solid gray",
        padding: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "info.main",
            }}
          >
            فایل های بارگذاری شده:
          </Typography>
        </Button>
      </Box>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
          {docs.map(
            (item, index) =>
              item.filePath && (
                <Grid item xs={6} sx={{}}>
                  <Item>
                    <img
                      style={{
                        width: "100%",
                      }}
                      src={item.filePath}
                      alt=""
                    />
                    <RemoveDocButton
                      handleDeleteDoc={handleDeleteFile}
                      index={index}
                    />
                  </Item>
                </Grid>
              )
          )}
        </Grid>
      </Box>
    </Box>
  );
}
